import { App, BuildInfo, Profile } from 'stores/StartupStore';

import { AxiosInstance } from 'axios';
import { Result } from './Result';

export class StartupService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getAllApps = async (identityUrl: string) => {
    const response = await this.axiosInstance.get<Result<App[] | { data: App[] }>>(`${identityUrl}/api/v1/me/apps`);
    if (response.data && !response.data.isError && response.data.data) {
      return !Array.isArray(response.data.data) ? response.data.data?.data : response.data.data; // Needed for backward compatibility with old IDv1 API
    }
    throw Error(response.status === 500 ? 'There was an internal error while fetching list of apps.' : response.data.toString());
  };

  getProfile = async () => {
    const response = await this.axiosInstance.get<Result<Profile>>(`account/profile`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(
      response.status === 500 ? 'There was an internal error while fetching your profile information.' : response.data.toString()
    );
  };

  getBuildInfo = async () => {
    const response = await this.axiosInstance.get<Result<BuildInfo>>(`build-info`);
    if (response.data && !response.data.isError && response.data.data?.buildNumber) {
      return response.data.data;
    }
    throw Error('Build info is not available.');
  };

  getPermissions = async () => {
    const response = await this.axiosInstance.get<Result<{ permissions: string[] }>>(`account/privileges`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(response.status === 500 ? 'There was an internal error while fetching your permissions.' : response.data.toString());
  };
}

export default StartupService;
